import {
  AreaBenefitys,
  AreaContent,
  Container,
  ContentInfos,
  ImageWorks,
  TitleContent,
} from "./styles";

import HowWorksImg from "./assets/howWorks.png";
import BeneFitys from "../../components/benefitys";
import BannerPagesInst from "../../components/BannerPagesInst";
import { useEffect } from "react";

const HowItsWorks = () => {
  const handleGoToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    handleGoToTop();
  }, []);

  return (
    <Container>
      <BannerPagesInst title="como funciona a coob+?" />
      <AreaContent>
        <ImageWorks src={HowWorksImg} alt="como funciona" />
        <ContentInfos>
          <TitleContent>
            CONHEÇA NOSSO JEITO INTELIGENTE DE VIAJAR!
          </TitleContent>
          <p>
            Por meio da nossa Plataforma de Assinaturas de Viagens os viajantes
            adquirem diárias de hospedagem para utilizá-las em mais de 1.900
            hotéis por todo o Brasil, já com café da manhã inclusos.
          </p>
          <p>
            Todos os anos a quantidade de diárias escolhidas é renovada e o
            Viajante tem até 3 anos para utilizá-las, pagando um valor mensal.
          </p>
        </ContentInfos>
      </AreaContent>
      <AreaBenefitys>
        <BeneFitys />
      </AreaBenefitys>
    </Container>
  );
};

export default HowItsWorks;
